import { render } from "./ProfileView.vue?vue&type=template&id=27f7d12c&ts=true"
import script from "./ProfileView.vue?vue&type=script&lang=ts"
export * from "./ProfileView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__